import {radii, colors, tokens} from '@commercial-helios/ui/theme'
import React from 'react'
import styled from 'styled-components'

import {isValidBackgroundColor} from '@/utils/is-valid-background-color'
import Image from '@helios/shared/components/image'
import {Text} from '@helios/shared/styles/typography'
import type ImageSource from '@helios/shared/types/image'
import mq from '@helios/shared/utils/media-query'

interface Props {
    backgroundColor?: string
    count?: number
    className?: string
    heading: string
    content: string
    image: ImageSource
}

export const Step = ({backgroundColor, count, heading, content, image, className}: Props) => {
    const validatedBackgroundColor =
        backgroundColor && isValidBackgroundColor(backgroundColor) ? backgroundColor : 'default'

    return (
        <StyledStep
            className={className}
            $backgroundColor={colors.background[validatedBackgroundColor]}
        >
            <ContentWrapper>
                {count && (
                    <Count>
                        <Text variant="paragraph-large">{count}</Text>
                    </Count>
                )}
                <Text variant="title-base">{heading}</Text>
                <Text variant="paragraph-large">{content}</Text>
            </ContentWrapper>
            <StyledImage image={image} />
        </StyledStep>
    )
}

interface StyledStepProps {
    $backgroundColor: string
}

const StyledStep = styled.div<StyledStepProps>`
    display: grid;
    height: 100%;
    overflow: hidden;
    background-color: ${(props) => props.$backgroundColor};
    border-radius: ${radii.arc20};

    ${mq.min('sm')} {
        grid-template-columns: repeat(2, 1fr);
    }

    ${mq.min('lg')} {
        grid-template-columns: auto;
    }
`

const Count = styled.span`
    display: grid;
    align-items: center;
    justify-content: center;
    width: ${tokens.spacing40};
    height: ${tokens.spacing40};
    border: 1px solid ${tokens.shade900};
    border-radius: ${radii.circle};
`

const StyledImage = styled(Image)`
    width: 100%;
    align-self: flex-end;

    ${mq.min('sm')} {
        padding: ${tokens.spacing40} 0;
    }

    ${mq.min('lg')} {
        padding: 0;
    }
`

const ContentWrapper = styled.div`
    display: grid;
    padding: ${tokens.spacing20};
    grid-gap: ${tokens.spacing8};

    ${mq.min('sm')} {
        padding: ${tokens.spacing40};
        align-self: center;
    }

    ${mq.min('lg')} {
        align-self: auto;
    }
`
